import {
  UPDATE_CAN_RUN_EXTENSION,
  UPDATE_EXTENSION_INSTALLED,
} from '../constants/actions';

const DEFAULT_DEVICE_STATE = {
  can_run_extension: false,
  checked_can_run_extension: false,
  checked_extension_installed: false,
  extension_installed: false,
  should_install_extension: false,
};

const deviceReducer = (state = DEFAULT_DEVICE_STATE, action) => {
  switch (action.type) {
    case UPDATE_CAN_RUN_EXTENSION:
      return {
        ...state,
        can_run_extension: action.canRun,
        checked_can_run_extension: true,
        should_install_extension: !action.canRun && state.extension_installed,
      };
    case UPDATE_EXTENSION_INSTALLED:
      return {
        ...state,
        checked_extension_installed: true,
        extension_installed: action.installed,
        should_install_extension: state.can_run_extension && !action.installed,
      };
    default:
      return state;
  }
};

export default deviceReducer;
